export enum ETablePopups {
  GeneratePromocodes = 'GeneratePromocodes',
  RemoveEsims = 'RemoveEsims',
  AnalyticsPackages = 'AnalyticsPackages',
}
